import styled from "styled-components/macro";

export const Container = styled.div`
  font-size: 16px;
  margin: 0;
  text-indent: 0;
  z-index: 20000;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  cursor: pointer;
  padding: 15px 12px 14px 10px;
  width: 800px;
  text-align: left;
  background: var(--menu-color-fullscreen);
  border-radius: 14px;
  box-shadow: var(--card-drop-shadow-medium);

  .close {
    position: absolute;
    z-index: 10;
    right: 0;
    top: 0;
  }

  .scrollable {
    max-height: 350px;
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);

    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background: var(--scrollbar-track);
    }
    &::-webkit-scrollbar-thumb {
      background-color: var(--scrollbar-thumb);
      border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: var(--scrollbar-thumb-hover);
    }
  }

  .command-menu-options {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    .high-quality-switch {
      display: flex;
      align-items: center;
      gap: 5px;
      margin-right: 50px;
      margin-top: -6px;

      .label-container {
        color: var(--grey-1);
        text-align: left;

        .main-label {
          font-size: 16px;
          line-height: 1.3;
        }

        .sub-label {
          font-size: 12px;
          line-height: 1.3;

          &.active {
            color: var(--primary-cta-high-contrast);
          }
        }
      }

      &.disabled {
        pointer-events: none;
        opacity: 0.5;
      }
    }
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding-left: 4px;

    textarea {
      font-family: "Inter", sans-serif;
      font-size: 18px;
      font-weight: 500;
      line-height: 1.3;
      border: none;
      background: transparent;
      color: var(--grey-0);
      width: 95%;
      resize: none;
      min-height: 1.3em;
      max-height: 150px;
      overflow-y: auto;

      &.disabled {
        opacity: 0;
        pointer-events: none;
      }
      ::placeholder {
        color: var(--grey-0);
        opacity: 0.5;
      }
    }

    button {
      padding: 10px 15px;
      border-radius: 10px;
      font-size: 16px;
      font-weight: 500;
      font-family: "Inter";
      border: none;
      cursor: pointer;
      background: var(--primary-cta);
      color: var(--cta-text-color);

      &:hover {
        background: var(--primary-cta-hover);
      }

      &.disabled {
        background: var(--primary-cta-light);
        pointer-events: none;
      }
    }

    .text-button-inner svg path {
      fill: var(--grey-0);
    }

    .icon-button-wrapper.disabled {
      cursor: default;
      pointer-events: none;
      opacity: 0.3;
    }

    .quick-edit-instruction {
      font-size: 14px;
      color: var(--grey-1);
      font-weight: 500;
      padding-left: 2px;
    }

    .quick-edit-error {
      font-size: 14px;
      color: var(--error-color, #e74c3c);
      font-weight: 500;
      padding: 8px 10px;
      border-radius: 8px;
      background: var(--error-bg, rgba(231, 76, 60, 0.1));
      margin-bottom: 4px;
    }

    .quick-actions {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;
      gap: 10px;

      button {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;

        .keyboard-shortcut {
          border: 2px solid rgba(255, 255, 255, 0.4);
          border-radius: 5px;
          path {
            fill: #fff;
          }
        }

        .keyboard-shortcut-container {
          display: flex;
          align-items: center;
          gap: 3px;
        }
      }

      .edit-choices {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;

        .like-container {
          position: relative !important;
          bottom: 0px;
          right: 0px;
          gap: 2px;
          display: flex;
          align-items: center;

          svg.thumb {
            width: 24px;
            height: 24px;
            padding: 0;

            path {
              fill: var(--grey-1);
            }
          }
        }
      }

      a {
        display: block;
      }
    }
  }

  /* .buttons {
    display: flex;
  } */
`;

export const DotContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  height: 24px;
  margin-left: 6px;

  .dot {
    height: 6px;
    width: 6px;
    border-radius: 50%;
    background-color: var(--grey-0);
    transform: translateY(4px);
    animation: bounce 1s ease-in-out infinite;

    &:nth-child(1) {
      animation-delay: 0s;
    }

    &:nth-child(2) {
      animation-delay: 0.33s;
    }

    &:nth-child(3) {
      animation-delay: 0.66s;
    }
  }

  @keyframes bounce {
    0%,
    100% {
      transform: translateY(4px);
    }
    50% {
      transform: translateY(-2px);
    }
  }
`;
